module.exports = __webpack_public_path__ + "static/media/form.223638dd.png";